import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { Button, Col, Container, Image, Row } from "react-bootstrap";

import {
	faChevronLeft,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Sentry from "@sentry/browser";

import ErrorImage from "../../assets/img/illustrations/500.svg";
import { routes } from "../../constants";

export const ServerError = ({
	message,
	error,
	report = true,
	eventId,
}: {
	message?: string;
	error?: any;
	// Set false when the caller has already reported to Sentry (e.g. the
	// ErrorBoundary, which captures with the component stack).
	report?: boolean;
	// Sentry event id from a caller that already reported (e.g. the
	// ErrorBoundary), shown to the user as a support reference.
	eventId?: string;
}) => {
	const [capturedEventId, setCapturedEventId] = useState<string>();

	// Report once per mounted error — not on every render — and never
	// capture an undefined error. Keep the event id for the reference below.
	useEffect(() => {
		if (report && error != null) {
			console.error(error);
			setCapturedEventId(Sentry.captureException(error));
		}
	}, [report, error]);

	// Prefer the caller-supplied id (already reported), else the one we captured.
	const referenceId = eventId ?? capturedEventId;

	if (!message) {
		message =
			error instanceof Error || error instanceof AxiosError
				? error.message
				: error != null
					? JSON.stringify(error)
					: "An unexpected error occurred";
	}

	return (
		<main>
			<section className="vh-100 d-flex align-items-center justify-content-center">
				<Container>
					<Row className="align-items-center">
						<Col
							xs={12}
							lg={5}
							className="order-2 order-lg-1 text-center text-lg-left"
						>
							<h1 className="text-primary mt-5">
								Something has gone wrong
							</h1>
							<p className="lead my-4">{message}</p>
							{referenceId && (
								<p className="text-muted small mb-4">
									Reference:{" "}
									<code>{referenceId}</code>
								</p>
							)}
							<Button
								variant="primary"
								className="animate-hover"
								onClick={() =>
									((window as Window).location =
										routes.presentation.path)
								}
							>
								<FontAwesomeIcon
									icon={faChevronLeft}
									className="animate-left-3 me-3 ms-2"
								/>
								Go back home
							</Button>
							<Button
								variant="primary"
								className="animate-hover ms-3"
								onClick={() =>
									((window as Window).location =
										routes.maintenance.path)
								}
							>
								Check Maintenance Page
								<FontAwesomeIcon
									icon={faChevronRight}
									className="animate-left-3 ms-2 me-2"
								/>
							</Button>
						</Col>
						{/* <Col
							xs={12}
							lg={7}
							className="order-1 order-lg-2 text-center d-flex align-items-center justify-content-center"
						>
							<Image
								src={ErrorImage}
								className="img-fluid w-75"
							/>
						</Col> */}
					</Row>
				</Container>
			</section>
		</main>
	);
};
